import { Userinfo } from 'components/pages/sign-up/types'
import { apiClient } from 'modules/api/client'

export async function getUserInfo(): Promise<Userinfo> {
  const response = await apiClient.get('/userinfo', { withCredentials: true })
  return response.data
}
